export var INPUT_TYPE = {
    mouse: 'mouse',
    touch: 'touch'
};

export var ENLARGED_IMAGE_POSITION = {
    over: 'over',
    beside: 'beside'
};